class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.allResetButton = document.querySelectorAll('button[type="reset"]');
    this.form = this.querySelector(".m-search-form");

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          // 搜索框输入行为日志
          if (event.target.value.length > 0) {
            const logData = {
              action_type: "search_input",
              request_json: { search_input_text: event.target.value },
            };
            sendBehaviorLog(logData);
          }
          this.onChange(event);
        }, 300).bind(this)
      );
      // 搜索框触发行为日志
      this.input.addEventListener("focus", () => {
        const logData = {
          action_type: "search_activate",
        };
        sendBehaviorLog(logData);
      });
    }

    if (this.form) {
      this.form.addEventListener("submit", (event) => {
        // 搜索框提交行为日志
        const logData = {
          action_type: "search_execute",
          request_json: { search_execute_text: this.input.value },
        };
        sendBehaviorLog(logData);
      });
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("m:hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.allResetButton &&
        this.allResetButton.forEach((button) => {
          button.classList.remove("m:hidden");
        });
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.allResetButton &&
        this.allResetButton.forEach((button) => {
          button.classList.add("m:hidden");
        });
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define("search-form", SearchForm);
